module.exports = __webpack_public_path__ + "img/oil_paint_2.840659c7.png";